module.exports = __webpack_public_path__ + "img/10.7ef369f3.jpg";